var pageCountLocation = function pageCountLocation(location) {
  switch (location) {
    case 'bottom-start':
      return 'start';
    case 'bottom-center':
      return 'center';
    case 'bottom-end':
      return 'end';
    default:
      return undefined;
  }
};

export { pageCountLocation };
//# sourceMappingURL=pageCountLocation.js.map
